'use strict';
module.exports = [
  require('./concat'),
  require('./cross'),
  require('./det'),
  require('./diag'),
  require('./dot'),
  require('./eye'),
  require('./expm'),
  require('./filter'),
  require('./flatten'),
  require('./forEach'),
  require('./inv'),
  require('./kron'),
  require('./map'),
  require('./ones'),
  require('./partitionSelect'),
  require('./range'),
  require('./reshape'),
  require('./resize'),
  require('./size'),
  require('./sort'),
  require('./sqrtm'),
  require('./squeeze'),
  require('./subset'),
  require('./trace'),
  require('./transpose'),
  require('./zeros')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/matrix/index.js
// module id = 1787
// module chunks = 0